/**
 * The consent screen.
 *
 * Anyone can register a client — that is what dynamic registration means — so
 * this screen is the only place access is actually decided. The wording says
 * what the connection could do and what it could not, because "an app wants
 * access" is a sentence people click past.
 */
const en = {
  title: 'Connect an assistant',
  wantsAccess: 'is asking to read this organization’s ReplayOps data.',
  organization: 'Organization',
  canRead: 'Read sessions, errors, tickets and analytics',
  canAct: 'Act with your role. Never more than you can do yourself',
  cannotExceed: 'See only the organization you choose here',
  cannotSignIn: 'Cannot sign in as you, change settings, or reach another organization',
  revokeHint: 'You can take this back at any time under Admin → API Keys.',
  approve: 'Approve',
  approving: 'Approving…',
  deny: 'Deny',
  failed: 'The connection could not be approved.',
  invalidRequest: 'This connection request is not valid. Ask the client to start again.',
  connections: 'Connected assistants',
  connectionsBody:
    'Assistants you approved through MCP. Revoking one stops it on its next call, not when its token expires.',
  revoke: 'Revoke',
  noConnections:
    'No assistants are connected yet. Add this deployment as an MCP server in Slack, Microsoft 365, '
    + 'Claude or Cursor; approving the connection there puts it here.',
  approvedOn: 'Approved',
  lastUsed: 'Last used',
  never: 'never',
};

const tr: typeof en = {
  title: 'Bir asistan bağla',
  wantsAccess: 'bu organizasyonun ReplayOps verisini okumak için izin istiyor.',
  organization: 'Organizasyon',
  canRead: 'Oturumları, hataları, talepleri ve analitiği okur',
  canAct: 'Sizin rolünüzle hareket eder. Kendi yapabildiğinizden fazlasını asla yapamaz',
  cannotExceed: 'Yalnızca burada seçtiğiniz organizasyonu görür',
  cannotSignIn: 'Sizin adınıza giriş yapamaz, ayarları değiştiremez, başka bir organizasyona erişemez',
  revokeHint: 'İstediğiniz an Admin → API Anahtarları altından geri alabilirsiniz.',
  approve: 'Onayla',
  approving: 'Onaylanıyor…',
  deny: 'Reddet',
  failed: 'Bağlantı onaylanamadı.',
  invalidRequest: 'Bu bağlantı isteği geçerli değil. İstemciden yeniden başlamasını isteyin.',
  connections: 'Bağlı asistanlar',
  connectionsBody:
    'MCP üzerinden onayladığınız asistanlar. Birini iptal etmek onu bir sonraki çağrısında durdurur, token’ı dolduğunda değil.',
  revoke: 'İptal et',
  noConnections:
    'Henüz bağlı asistan yok. Bu kurulumu Slack, Microsoft 365, Claude ya da Cursor içinde MCP sunucusu '
    + 'olarak ekleyin; oradaki bağlantıyı onayladığınızda burada görünür.',
  approvedOn: 'Onaylandı',
  lastUsed: 'Son kullanım',
  never: 'hiç',
};

export const oauth = { en, tr };
